<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIsoIzlemKriterleri from "@/models/StrIsoIzlemKriterleri";
export default {
  mixins: [Api, Sabit, StrIsoIzlemKriterleri],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    formtextarea,
    forminput, BirimSecimi
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("StrIsoIzlemKriterleri", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.StrIsoIzlemKriterleriData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIsoIzlemKriterleri");
            }
          });
        } else {
          this.Update("StrIsoIzlemKriterleri", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrIsoIzlemKriterleriData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIsoIzlemKriterleri");
            }
          });
        }
      }
    },
    Get() { },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIsoIzlemKriterleri" size="lg" :title="this.AddEdit == 'Edit'
      ? 'Kaydı Düzenle'
      : 'Kayıt Ekle'
      " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">

          <BirimSecimi class="mb-3 col-md-6" :title="FormDataType.Birimids.FieldTitle" :sutun="'0'"
            :title_position="'mb-3'" :selected="FormData.Birimids" :labels_lg="'3'" :v="$v.FormData.Birimids"
            :multiple="true" :BirimTipId="null" @Secilmis_Idler="FormData.Birimids = $event" />

          <forminput class="col-md-6" :FormDataType="FormDataType.No" :Value="FormData.No" :v="$v.FormData.No"
            @input="FormData.No = $event" />

          <forminput class="col-md-6" :FormDataType="FormDataType.Surec" :Value="FormData.Surec" :v="$v.FormData.Surec"
            @input="FormData.Surec = $event" />
          <formtextarea class="col-md-6" :FormDataType="FormDataType.Kriter" :Value="FormData.Kriter"
            :v="$v.FormData.Kriter" @input="FormData.Kriter = $event" />

        </div>
        <button class="btn btn-primary" type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
